import React from "react";
import { getDestinationIcon } from "../DestinationModal.config";

interface DestinationIconProps {
    code?: string;
    size?: "small" | "medium" | "large";
    alt?: string;
    className?: string;
}

const DestinationIcon: React.FC<DestinationIconProps> = ({
    code,
    size = "medium",
    alt = "Destination Icon",
    className = "",
}) => {
    const iconSrc = getDestinationIcon(code);

    const sizeMap = {
        small: 24,
        medium: 40,
        large: 60,
    };

    const iconSize = sizeMap[size];

    if (!iconSrc) {
        return null;
    }

    return (
        <img
            src={iconSrc}
            alt={alt}
            width={iconSize}
            height={iconSize}
            className={className}
            style={{ objectFit: "contain" }}
        />
    );
};

export default DestinationIcon;
